export interface Module {
  title: string
  body: string
  /** Spine color of the matching book in the box-set mockup */
  color: string
}

export const modules: Module[] = [
  {
    title: 'MODULE 1 — PLANT NUTRIENT DEFICIENCY IDENTIFICATION ATLAS',
    body: 'Recognize nitrogen, phosphorus, potassium, calcium, magnesium, iron, zinc, and other essential nutrient deficiencies using annotated symptom references, leaf discoloration patterns, visual comparison charts, and deficiency identification guides.',
    color: '#1F6B3A',
  },
  {
    title: 'MODULE 2 — NUTRIENT TOXICITY, IMBALANCE & PLANT STRESS ATLAS',
    body: 'Differentiate nutrient excesses, toxicities, fertilizer injury, salinity stress, and nutritional imbalances using side-by-side symptom comparisons, nutrient interaction diagrams, and structured assessment references.',
    color: '#C62828',
  },
  {
    title: 'MODULE 3 — SOIL, pH, EC & NUTRIENT AVAILABILITY VISUAL GUIDE',
    body: 'Understand how soil pH, electrical conductivity, nutrient availability, soil conditions, and root-zone factors influence plant nutrition through illustrated charts, interpretation guides, and practical visual references.',
    color: '#7A4A23',
  },
  {
    title: 'MODULE 4 — LEAF TISSUE ANALYSIS & NUTRIENT DIAGNOSTIC INTERPRETATION',
    body: 'Connect laboratory findings with visible crop symptoms using tissue analysis reference frameworks, annotated report examples, sampling diagrams, nutrient comparison charts, and structured interpretation worksheets.',
    color: '#1E6FC9',
  },
  {
    title: 'MODULE 5 — CROP-SPECIFIC NUTRITION & DEFICIENCY VISUAL ATLAS',
    body: 'Explore nutritional disorder patterns across vegetables, fruits, cereals, legumes, greenhouse crops, and hydroponic systems with crop-specific symptom galleries, visual comparisons, and practical reference cases.',
    color: '#E07A1F',
  },
  {
    title: 'MODULE 6 — PLANT NUTRITION DIAGNOSTIC WORKFLOW & FIELD REFERENCE SYSTEM',
    body: 'Organize crop nutrition assessments with symptom identification charts, field inspection workflows, diagnostic decision trees, observation checklists, sampling guides, and professional documentation resources.',
    color: '#6B3FA0',
  },
]
